import React from 'react';
import { Refrigerator, Flame, Droplets, Wind, Microwave, Coffee, CheckCircle, ArrowRight } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { Card } from '../components/ui/card';

const Appliances = () => {
  const { language } = useLanguage();

  const products = [
    {
      icon: Refrigerator,
      title: { fr: 'Réfrigérateurs et Congélateurs', en: 'Refrigerators and Freezers' },
      description: { fr: 'Conservation optimale pour vos produits', en: 'Optimal preservation for your products' },
      image: 'https://images.unsplash.com/photo-1591640375708-6a976b40547b',
      specs: [
        { fr: 'Capacités de 200L à 1000L', en: 'Capacities from 200L to 1000L' },
        { fr: 'Réfrigérateurs professionnels', en: 'Professional refrigerators' },
        { fr: 'Congélateurs à tiroirs', en: 'Drawer freezers' },
        { fr: 'Technologie No Frost', en: 'No Frost technology' },
        { fr: 'Économie d\'énergie A+++', en: 'A+++ energy efficiency' }
      ]
    },
    {
      icon: Flame,
      title: { fr: 'Cuisinières et Plaques', en: 'Stoves and Cooktops' },
      description: { fr: 'Équipements de cuisson professionnels', en: 'Professional cooking equipment' },
      image: 'https://images.pexels.com/photos/6375558/pexels-photo-6375558.jpeg',
      specs: [
        { fr: 'Cuisinières 4 à 8 feux', en: '4 to 8 burner stoves' },
        { fr: 'Gaz, électrique et induction', en: 'Gas, electric and induction' },
        { fr: 'Fours professionnels intégrés', en: 'Integrated professional ovens' },
        { fr: 'Acier inoxydable', en: 'Stainless steel' },
        { fr: 'Contrôles de température précis', en: 'Precise temperature controls' }
      ]
    },
    {
      icon: Droplets,
      title: { fr: 'Lave-Vaisselle', en: 'Dishwashers' },
      description: { fr: 'Nettoyage efficace et rapide', en: 'Efficient and fast cleaning' },
      image: 'https://images.unsplash.com/photo-1662135426688-bf91aaea6ea9',
      specs: [
        { fr: 'Lave-vaisselle professionnels', en: 'Professional dishwashers' },
        { fr: 'Capacité 12 à 16 couverts', en: 'Capacity 12 to 16 place settings' },
        { fr: 'Programmes rapides 30 min', en: 'Quick 30 min programs' },
        { fr: 'Séchage automatique', en: 'Automatic drying' },
        { fr: 'Économie d\'eau et d\'énergie', en: 'Water and energy saving' }
      ]
    },
    {
      icon: Droplets,
      title: { fr: 'Lave-Linge Professionnels', en: 'Professional Washing Machines' },
      description: { fr: 'Machines industrielles haute capacité', en: 'High capacity industrial machines' },
      image: 'https://images.unsplash.com/photo-1604335399105-a0c585fd81a1',
      specs: [
        { fr: 'Capacités 10kg à 30kg', en: 'Capacities 10kg to 30kg' },
        { fr: 'Tambour en acier inoxydable', en: 'Stainless steel drum' },
        { fr: 'Programmation électronique', en: 'Electronic programming' },
        { fr: 'Cycles rapides et économiques', en: 'Quick and economical cycles' },
        { fr: 'Usage intensif garanti', en: 'Heavy-duty guaranteed' }
      ]
    },
    {
      icon: Wind,
      title: { fr: 'Sèche-Linge Industriels', en: 'Industrial Dryers' },
      description: { fr: 'Séchage rapide et uniforme', en: 'Fast and uniform drying' },
      image: 'https://images.pexels.com/photos/2254065/pexels-photo-2254065.jpeg',
      specs: [
        { fr: 'Capacités 10kg à 30kg', en: 'Capacities 10kg to 30kg' },
        { fr: 'Gaz et électrique', en: 'Gas and electric' },
        { fr: 'Contrôle d\'humidité', en: 'Humidity control' },
        { fr: 'Séchage uniforme', en: 'Uniform drying' },
        { fr: 'Économie d\'énergie', en: 'Energy saving' }
      ]
    },
    {
      icon: Microwave,
      title: { fr: 'Fours Micro-Ondes', en: 'Microwave Ovens' },
      description: { fr: 'Réchauffage rapide et efficace', en: 'Fast and efficient reheating' },
      image: 'https://images.unsplash.com/photo-1585659722983-3a675dabf23d',
      specs: [
        { fr: 'Puissance 800W à 1200W', en: 'Power 800W to 1200W' },
        { fr: 'Capacités 20L à 40L', en: 'Capacities 20L to 40L' },
        { fr: 'Fonction grill intégrée', en: 'Integrated grill function' },
        { fr: 'Programmation automatique', en: 'Automatic programming' },
        { fr: 'Design professionnel', en: 'Professional design' }
      ]
    },
    {
      icon: Coffee,
      title: { fr: 'Machines à Café Professionnelles', en: 'Professional Coffee Machines' },
      description: { fr: 'Café de qualité pour vos équipes', en: 'Quality coffee for your teams' },
      image: 'https://images.unsplash.com/photo-1620807773206-49c1f2957417',
      specs: [
        { fr: 'Machines espresso automatiques', en: 'Automatic espresso machines' },
        { fr: 'Moulins intégrés', en: 'Integrated grinders' },
        { fr: 'Mousseur de lait', en: 'Milk frother' },
        { fr: 'Écran tactile', en: 'Touch screen' },
        { fr: 'Maintenance facile', en: 'Easy maintenance' }
      ]
    },
    {
      icon: Flame,
      title: { fr: 'Cuisine Professionnelle Complète', en: 'Complete Professional Kitchen' },
      description: { fr: 'Installation clé en main', en: 'Turnkey installation' },
      image: 'https://images.unsplash.com/photo-1588416820614-f8d6ac6cea56',
      specs: [
        { fr: 'Conception sur mesure', en: 'Custom design' },
        { fr: 'Équipement complet', en: 'Complete equipment' },
        { fr: 'Installation professionnelle', en: 'Professional installation' },
        { fr: 'Normes sanitaires respectées', en: 'Health standards compliant' },
        { fr: 'Formation du personnel', en: 'Staff training' }
      ]
    }
  ];

  return (
    <div className="min-h-screen">
      <section className="relative py-32 overflow-hidden" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1570222094114-d054a817e56b)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900/95 to-blue-900/90"></div>
        <div className="relative z-10 container mx-auto px-4 text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-600 rounded-full mb-6">
            <Refrigerator className="h-8 w-8 text-white" />
          </div>
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            {language === 'fr' ? 'Électroménager Professionnel' : 'Professional Appliances'}
          </h1>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            {language === 'fr' ? 'Équipements électroménagers de qualité pour votre entreprise' : 'Quality appliances for your business'}
          </p>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-br from-slate-50 to-blue-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              {language === 'fr' ? 'Notre Gamme Complète' : 'Our Complete Range'}
            </h2>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {products.map((product, index) => {
              const Icon = product.icon;
              return (
                <Card key={index} className="overflow-hidden hover:shadow-2xl transition-all duration-300 bg-white">
                  <div className="relative h-64 overflow-hidden">
                    <img src={product.image} alt={product.title[language]} className="w-full h-full object-cover hover:scale-110 transition-transform duration-500" />
                    <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 to-transparent"></div>
                    <div className="absolute bottom-4 left-4">
                      <div className="w-14 h-14 bg-white/90 backdrop-blur-sm rounded-lg flex items-center justify-center">
                        <Icon className="h-7 w-7 text-blue-600" />
                      </div>
                    </div>
                  </div>

                  <div className="p-8">
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">{product.title[language]}</h3>
                    <p className="text-gray-600 mb-6">{product.description[language]}</p>
                    <ul className="space-y-3">
                      {product.specs.map((spec, idx) => (
                        <li key={idx} className="flex items-start text-sm text-gray-700">
                          <CheckCircle className="h-5 w-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" />
                          <span>{spec[language]}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      <section className="py-20 bg-blue-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            {language === 'fr' ? 'Installation Professionnelle Incluse' : 'Professional Installation Included'}
          </h2>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
            {language === 'fr' ? 'Tous nos équipements sont installés par nos techniciens qualifiés' : 'All our equipment is installed by our qualified technicians'}
          </p>
          <a href="/contact">
            <button className="bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors text-lg inline-flex items-center">
              {language === 'fr' ? 'Demander un Devis' : 'Request a Quote'}
              <ArrowRight className="ml-2 h-5 w-5" />
            </button>
          </a>
        </div>
      </section>
    </div>
  );
};

export default Appliances;
